"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplaySpectatorsDto = void 0;
class GetDisplaySpectatorsDto {
    displayId;
    from;
    groupBy;
    to;
    maxDistance;
}
exports.GetDisplaySpectatorsDto = GetDisplaySpectatorsDto;
